export default {
  data() {
    return {
      customIO: null,
      isObserved: false,
      inViewport: false,
    };
  },
  mounted() {
    this.$el.onIntersect = (entry) => {
      if (this.inViewport) {
        return;
      }

      this.inViewport = true;

      if (typeof this.onViewportEnter === 'function') {
        this.onViewportEnter(entry);
      }
    };

    this.$el.onOutersect = (entry) => {
      if (!this.inViewport) {
        return;
      }

      this.inViewport = false;

      if (typeof this.onViewportLeave === 'function') {
        this.onViewportLeave(entry);
      }
    };
  },
  beforeDestroy() {
    this.unobserve();
  },
  methods: {
    observe(options = {}) {
      if (this.isObserved) {
        return;
      }

      this.isObserved = true;
      this.inViewport = false;

      const { root, rootMargin, threshold } = options;
      const isCustom = root || rootMargin || threshold;

      if (isCustom) {
        this.customIO = this.$window.createCustomIO(options);
        this.customIO.observe(this.$el);
      } else {
        this.$window.io.observe(this.$el);
      }
    },
    unobserve() {
      if (!this.isObserved) {
        return;
      }

      this.isObserved = false;
      this.inViewport = false;

      if (this.customIO) {
        this.customIO.unobserve(this.$el);
        this.customIO = null;
      } else {
        this.$window.io.unobserve(this.$el);
      }
    },
    onViewportEnter() {},
    onViewportLeave() {},
  },
};
